import React, { PureComponent } from 'react';

class FilterBar extends PureComponent {

  render(){
    return (
      <div className="filter-bar">
        <span className="label" style={{'display': (this.props.active === "") ? 'none' : 'inline-block'}} onClick={e => this.props.onSelect(null)}>
          reset filter &nbsp;
          <svg width="9" height="9" viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.187 4.5L8.884.803a.324.324 0 0 0 0-.458l-.229-.23a.324.324 0 0 0-.458 0L4.5 3.814.803.119a.324.324 0 0 0-.458 0l-.23.229a.324.324 0 0 0 0 .458L3.814 4.5.119 8.197a.324.324 0 0 0 0 .458l.229.23a.324.324 0 0 0 .458 0L4.5 5.186l3.697 3.697a.324.324 0 0 0 .458 0l.23-.229a.324.324 0 0 0 0-.458L5.186 4.5z" fill="#B9B3AE" fillRule="nonzero"/>
          </svg>
        </span>

      </div>
    )
  }
}

export default FilterBar;



// WEBPACK FOOTER //
// ./src/components/tripSearch/filters/filterbar.js